import {Injectable} from '@angular/core';
import {ApiClientService} from '../api-client.service';
import {Observable} from 'rxjs/Observable';
import {ICorporationNumberSettings} from '../../types/api-response/sms-notification';
import {SettingsSms} from '../../types/models';
import {map} from 'rxjs/operators';

@Injectable()
export class SmsNotificationApiService {

    constructor(private api: ApiClientService) {
    }

    corporationNumberSettings(corporationNumberId: number): Observable<SettingsSms> {
        return (this.api.getJson('domainSms', `/v1/cn_settings/${corporationNumberId}.json`) as Observable<ICorporationNumberSettings>)
            .pipe(
                map(SettingsSms.fromCorporationNumberSettings)
            );
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/api/sms-notification-api.service.ts